"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _icons = require("../../icons");

var _layout = require("../../layout");

var _utils = require("../../utils");

var _constants = require("../constants");

var _InputFooterIcon = _interopRequireDefault(require("./InputFooterIcon"));

var _InputFooterText = _interopRequireDefault(require("./InputFooterText"));

var _core = require("@emotion/core");

var _excluded = ["children", "warning", "error", "icon", "gridGap", "alignItems", "iconAltText"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var iconRenderer = function iconRenderer(_ref) {
  var warning = _ref.warning,
      error = _ref.error,
      iconAltText = _ref.iconAltText,
      providedIcon = _ref.icon;
  var icon = providedIcon === null ? null : providedIcon || (error ? (0, _core.jsx)(_icons.IconAlertCircleFill, {
    size: _icons.IconSize.ExtraSmall,
    title: iconAltText || 'Error'
  }) : warning ? (0, _core.jsx)(_icons.IconAlertTriangleFill, {
    size: _icons.IconSize.ExtraSmall,
    title: iconAltText || 'Warning'
  }) : null);
  return icon ? (0, _core.jsx)(_InputFooterIcon.default, {
    error: error,
    warning: warning
  }, icon) : null;
};

var InputFooterBase = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var children = _ref2.children,
      warning = _ref2.warning,
      error = _ref2.error,
      icon = _ref2.icon,
      _ref2$gridGap = _ref2.gridGap,
      gridGap = _ref2$gridGap === void 0 ? _constants.INPUT_GRID_GAP : _ref2$gridGap,
      _ref2$alignItems = _ref2.alignItems,
      alignItems = _ref2$alignItems === void 0 ? 'flex-start' : _ref2$alignItems,
      iconAltText = _ref2.iconAltText,
      transferProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  return (0, _core.jsx)(_layout.Row, (0, _extends2.default)({
    ref: ref,
    gridGap: gridGap,
    alignItems: alignItems
  }, transferProps), iconRenderer({
    warning: warning,
    error: error,
    icon: icon,
    iconAltText: iconAltText
  }), !!children ? typeof children === 'string' ? (0, _core.jsx)(_InputFooterText.default, null, children) : children : null);
});
var InputFooterWithDocs = (0, _stencilReactDesc.describe)(InputFooterBase).description('Used in conjunction with form components to display additional information related to a form field');
InputFooterWithDocs.propTypes = _objectSpread(_objectSpread({}, _layout.Row.describedPropTypes), {}, {
  children: _stencilReactDesc.PropTypes.node.description('Content to display in the InputFooter. Normally a plain string.'),
  icon: _stencilReactDesc.PropTypes.any.description('Icon to display on the left of the InputFooter.').format('component type'),
  error: _stencilReactDesc.PropTypes.bool.description('Styles the field to indicate that the value is incorrect and cannot be used.'),
  warning: _stencilReactDesc.PropTypes.bool.description("Styles the field to indicate that it requires the user's attention."),
  iconAltText: _stencilReactDesc.PropTypes.string.description('Alt text for the icon displayed on the leading side of the footer. The text should be tailored to the type of footer.')
});
var InputFooter = (0, _utils.withTestAttributes)({
  component: 'StencilReactInputFooter'
})(InputFooterWithDocs);
InputFooter.displayName = 'InputFooter';
var _default = InputFooter;
exports.default = _default;